import React, { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/PanelHeader/PanelHeader";
import { PanelFooter } from "../../../components/PanelFooter/PanelFooter";
import { ComboBox, Panel, PanelType } from "@fluentui/react";

import { IOpenPanel } from "../../../interfaces/base/IPanel";
import UseAsignarEmpresa from "./UseAsignarEmpresa";
import {
  IBase,
  IException,
  IItemComboBaseDTO,
} from "../../../interfaces/base/IBase";
import TransporteService from "../../../services/transporteService";
import { ProgressBarLoading } from "../../../components/ProgressBarLoading/ProgressBarLoading";
import { MessageBarResponse } from "../../../components/MessageBar/MessageBarResponse";

export interface IPanelAsignarEmpresa extends IOpenPanel {
  dataMov: any;
  reloadInitial?: any;
}

const PanelAsignarEmpresa = (props: IPanelAsignarEmpresa) => {
  const [transporte, setTransporte] = useState<IItemComboBaseDTO[]>([]);

  const {
    setRequest,
    onchangeCombo,
    disabled,
    setDisabled,
    AgregarEmpresa,
    mensaje,
    status,
    loading,
    setLoading,
    setStatus,
    setMensaje,
    request,
  } = UseAsignarEmpresa(
    props.dataMov,
    undefined,
    props.onDismiss,
    props.reloadInitial
  );

  useEffect(() => {
    if (props.isOpen) {
      setRequest({
        empresaId: "",
        lugarMovilizacionId: props.dataMov?.lugarMovilizacionId,
      });
      setDisabled(true);
      setLoading(false);
      setMensaje("");
      setStatus(0);
    }
  }, [props.isOpen]);

  const dataTransporte = () => {
    TransporteService.allSocioTransportista()
      .then((res) => {
        let d: IBase[] = res.data;

        let t: IItemComboBaseDTO[] = d.map((x) => {
          return {
            key: x.id,
            text: x.nombre,
          };
        });

        setTransporte(t);
      })
      .catch((e: IException) => {
        console.log(e);
      });
  };

  useEffect(() => {
    dataTransporte();
  }, []);

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="add"
          textHeader={`Movilizaciones`}
          subTextHeader={`Asignar Empresas de Transporte`}
        />
      </>
    ),
    []
  );

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Agregar"
          disableButton={disabled}
          onClick={AgregarEmpresa}
          onDismiss={props.onDismiss}
        />
      </>
    ),
    [disabled, request]
  );

  return (
    <>
      <Panel
        type={PanelType.smallFixedFar}
        onRenderHeader={onRenderHeader}
        onRenderFooter={onRenderFooter}
        isFooterAtBottom
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
      >
        <div className="ms-Grid" dir="ltr">
          <div hidden={mensaje === ""}>
            <MessageBarResponse
              objetoResponse={{ codigo: status, mensaje: mensaje }}
              close={true}
            />
          </div>
          <div hidden={!loading}>
            <ProgressBarLoading></ProgressBarLoading>
          </div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <ComboBox
              label={"Empresa Transportista"}
              allowFreeform
              autoComplete="on"
              disabled={false}
              useComboBoxAsMenuWidth
              openOnKeyboardFocus
              calloutProps={{ directionalHintFixed: true }}
              options={transporte}
              onChange={(e, option) => onchangeCombo(option, "empresaId")}
            />
          </div>
        </div>
      </Panel>
    </>
  );
};

export default PanelAsignarEmpresa;
